import { Component, HostListener } from '@angular/core';
import { ModalController } from 'ionic-angular';
import moment from 'moment';
import { NgxSpinnerService } from "ngx-spinner";
import { ServicioProvider } from '../../providers/servicio/servicio';
import { MyApp } from '../../app/app.component';
import {
  aggregateOrderStatistics,
  formatMoney,
  OrderStatistics,
  OrderSummaryInput
} from '../../utils/order-statistics';

@Component({
  selector: 'pedidos',
  templateUrl: 'pedidos.html'
})
export class PedidosComponent {


  lista_pedidos: any = [];
  pedidos_del_dia: OrderSummaryInput[] = [];
  estadisticas: OrderStatistics = aggregateOrderStatistics([]);

  fecha_seleccionada = "";
  fecha = "";

  array_locaciones: any = [];
  lista_pedidos_filtro: any = [];
  tamano_lbl_titulo = "";
  tamano_lbl_locacion = "";
  tamano_lbl_input = "";
  tamano_lbl_fecha = "";

  tamano_lbl_titulo_tabla = "";
  tamano_lbl_texto_tabla = "";
  tamano_lbl_texto_tabla_moneda = "";


  tamano_lbl_texto_tabla_vertical_moneda = "9px";
  tamano_lbl_texto_tabla_vertical = "13px";

  idlocacion = "";
  name_locacion = "";
  busqueda = "";
  ver_locacion = false;
  bloquea_mixto = 0;
  reportes:any = [];
  bloquea_fecha =0;


  constructor(public servicio: ServicioProvider, public inicio_menu:MyApp, public modal: ModalController, public spiner: NgxSpinnerService) {
    this.Inicio();
  }

  Inicio() {

    this.responsivos();
    this.array_locaciones = this.servicio.ver_locaciones();
    this.sincronizarLocacionActual();

    this.fecha_seleccionada = moment().format('DD/MM/YYYY');
    var array_fecha = this.fecha_seleccionada.split("/");

    this.fecha = array_fecha[2] + "-" + array_fecha[1] + "-" + array_fecha[0]; // + "-07";  fecha 07 tiene datos
    var array_save_fecha = [];
    array_save_fecha.push({
      fecha: this.fecha_seleccionada,
      json_fecha: this.fecha
    })
    this.servicio.save_fecha(array_save_fecha);


    

    this.consultar_pedido();

  }

  cambiar_locacion() {

    // Catálogos y Punto de Venta pueden cambiar la locación compartida sin
    // recrear este componente. Reflejarla antes de abrir el selector.
    this.sincronizarLocacionActual();

    if (this.array_locaciones.length > 1) {
      this.ver_locacion = true;
    }
    else {
      this.ver_locacion = false;
    }

  }

  item_change_locacion(pos) {

    for (let i = 0; i < this.array_locaciones.length; i++) {
      this.array_locaciones[i].activo = "";
    }

    this.idlocacion = this.array_locaciones[pos].idlocacion;
    this.name_locacion = this.array_locaciones[pos].nombre;

    this.array_locaciones[pos].activo = "selected";
    this.servicio.cambiar_Locacion(this.array_locaciones[pos]);
    this.ver_locacion = false;

    this.consultar_pedido();
    let idlocacion = this.servicio.elegir_locacion().idlocacion;

    let json="apikey=" + this.servicio.ver_apikey_login() + "&idmodulo=30&idlocacion=" + idlocacion;
    
    this.servicio.lista_reportes(json).then(data => {
      if (data != 0) {
        this.servicio.save_nombre_reportes(data);
      }
      else {
        this.servicio.save_nombre_reportes([]);
      }   
      //this.tipo_spinner = this.config.tipo_spinner;
      this.inicio_menu.menu_lateral(data);  
    }); 
 
  }


  consultar_pedido() {

    // La consulta siempre debe usar la locación vigente en ServicioProvider,
    // no la copia que este componente conservó al construirse.
    if (!this.sincronizarLocacionActual()) {
      return;
    }

    this.spiner.show()
    this.busqueda="";
    this.lista_pedidos = [];
    let json = "fecha=" + this.fecha + "&idlocacion=" + this.idlocacion + "&apikey=" + encodeURIComponent(this.servicio.ver_apikey_login());

    this.servicio.get_ver_pedidos(json).then(data => {

      if (data != 0) {
        ////console.log(JSON.stringify(data));

        //this.lista_pedidos_filtro = [];
        this.pedidos_del_dia = data as OrderSummaryInput[];
        this.lista_pedidos_filtro = this.pedidos_del_dia.slice();
        this.lista_pedidos = this.pedidos_del_dia.slice();
        this.estadisticas = aggregateOrderStatistics(this.pedidos_del_dia);
        this.spiner.hide()
      }
      else {
        this.spiner.hide()
        this.lista_pedidos = [];
        this.pedidos_del_dia = [];
        this.lista_pedidos_filtro = [];
        this.estadisticas = aggregateOrderStatistics([]);
      }
    });

  }

  private sincronizarLocacionActual(): boolean {
    const locacionActual = this.servicio.elegir_locacion();
    if (!locacionActual || locacionActual.idlocacion === undefined || locacionActual.idlocacion === null) {
      return false;
    }

    const idActual = String(locacionActual.idlocacion);
    const locacion = (this.array_locaciones || []).filter((item: any) =>
      item && String(item.idlocacion) === idActual
    )[0];

    // No permitir consultar una locación que no sea parte de las locaciones
    // autorizadas que ya cargó la sesión.
    if (!locacion) {
      return false;
    }

    this.idlocacion = locacion.idlocacion;
    this.name_locacion = locacion.nombre;
    for (let i = 0; i < this.array_locaciones.length; i++) {
      this.array_locaciones[i].activo = String(this.array_locaciones[i].idlocacion) === idActual ? 'selected' : '';
    }
    return true;
  }

  format_money(amount: number, currency: string): string {
    return formatMoney(amount, currency);
  }

  detalle_pagos(item: any): any[] {
    return item && Array.isArray(item.detallepago) ? item.detallepago : [];
  }

  pago_unico(item: any): any | null {
    const pagos = this.detalle_pagos(item);
    return pagos.length === 1 ? pagos[0] : null;
  }

  abrir_modal_mixto(array_datos) {

   // console.log(JSON.stringify(array_datos));

    if (this.bloquea_mixto == 0) {
      this.bloquea_mixto++;
      let mandar_titulo = "Pago " + array_datos.tipopago;
      let modalc = this.modal.create('ModalPagoMixtoPage', {
        "array_datos": array_datos.detallepago, "ban": 1,  //ban 0 = visto   1 = pago mixto 
        "titulo": mandar_titulo, "orden": array_datos.idpedido
      },
        { cssClass: "class-modal-preview" });
      modalc.onDidDismiss((dato) => {
        this.bloquea_mixto = 0;

      });
      modalc.present();
      return;
    }
  }


  vistas(visto, array: any, idpedido) {

    if (visto > 0) {

      let mensaje = "";
      if (visto == 1) {
        mensaje = "Visto: " + visto + " vez";
      }
      else {
        mensaje = "Visto: " + visto + " veces";
      }

      if (this.bloquea_mixto == 0) {
        this.bloquea_mixto++;

        let modalc = this.modal.create('ModalPagoMixtoPage', {
          "array_datos": array, "orden": idpedido,
          "titulo": mensaje, "ban": 0  //ban 0 = visto   1 = pago mixto 
        },
          { cssClass: "class-modal-preview" });
        modalc.onDidDismiss((dato) => {
          this.bloquea_mixto = 0;
        });
        modalc.present();
        return;
      }
    }
  }
  

  abrir_modal_fecha() {
    if (this.bloquea_fecha == 0) {
      this.bloquea_fecha++;

      let modalc = this.modal.create('ModalFechaPage', { "asd": "asdd" },
        { cssClass: "class-modal-fecha"/*, enableBackdropDismiss: false*/ });
      modalc.onDidDismiss((data, data2) => {
        this.bloquea_fecha = 0;
        if (data == "1") {
          this.fecha_seleccionada = data2;
          var array_fecha = this.fecha_seleccionada.split("/");

          this.fecha = array_fecha[2] + "-" + array_fecha[1] + "-" + array_fecha[0];
          var array_save_fecha = [];
          array_save_fecha.push({
            fecha: this.fecha_seleccionada,
            json_fecha: this.fecha
          })
          this.servicio.save_fecha(array_save_fecha);
          this.consultar_pedido();

        }
      });
      modalc.present();
      return;
    }
  }

  buscar_pedido() {

    // //console.log("a")
    if (this.busqueda.length > 20) {
      let mensaje = 'máximo 20 caracteres';
      let modalFull = this.modal.create("ModalInformativoPage",
        { "btn": "1", "btn_text_aceptar": "Aceptar", "btn_text_cancelar": "Cancelar", "ver_img_btn": "false", "msj": mensaje },
        { cssClass: "class-modal-preview", enableBackdropDismiss: false })
      modalFull.onDidDismiss((dato) => {
        this.busqueda = "";
      });
      modalFull.present();
      return;
    }
    else if (this.busqueda.length >= 3 && this.busqueda.length <= 20) {
      const query = this.busqueda.toLowerCase();
      this.lista_pedidos = this.pedidos_del_dia.filter(function (pedido: any) {
        return [pedido.idpedido, pedido.cliente, pedido.correo].some(function (value) {
          return value !== null && value !== undefined && String(value).toLowerCase().indexOf(query) !== -1;
        });
      });
    }
    else if (this.busqueda.length <= 2) {
      this.lista_pedidos = [];
      this.lista_pedidos = this.pedidos_del_dia.slice();
    }

  }


  abrir_modal_detalles(array_datos) {

    if (this.bloquea_mixto == 0) {
      this.bloquea_mixto++;

      let modalc = this.modal.create('ModalDetallesOrdenesPage', { "array_datos": array_datos, "fecha_json": this.fecha, "fecha_s": this.fecha_seleccionada },
        { cssClass: "class-modal-preview"/*, enableBackdropDismiss: false*/ });
      modalc.onDidDismiss((data1, data2) => {
        this.bloquea_mixto = 0;

        //this.actualizar();

      });
      modalc.present();
      return
    }
  }

  cancelar_pedido(pedidoid, tipo) {
    let accion = "";
    if (tipo == 1)
      accion = "Bloquear orden: #";
    if (tipo == 2) {
      accion = "Desbloquear orden: #";
    }

    if (this.bloquea_mixto == 0) {
      this.bloquea_mixto++;

      let modalc = this.modal.create('ModalAutorizaPage', { "cambio": accion + pedidoid, "accion": tipo, "idlocacion": this.idlocacion, "idpedido": pedidoid },
        { cssClass: "class-modal-preview"/*, enableBackdropDismiss: false*/ });
      modalc.onDidDismiss((data, data2) => {
        this.bloquea_mixto = 0;
        if (data == "1") {
          this.consultar_pedido();
        }
      });

      modalc.present();
      return;
    }
  }

  color_venta(dato) {

    let style = "";
    if (dato == "Venta") {
      style = "#2866ed"
    }
    else {
      style = "#2866ed"
    }
    return style;

  }

  color_tipo(dato) {
    var style = "";
    ////console.log(dato);
    if (dato == 2) {
      style = "#e66e1e"
    }
    else {
      style = "black"
    }
    return style;
  }

  color_estatus(dato) {
    var style = "";
    ////console.log(dato);
    if (dato == 25) {
      style = "#ffffff"
    }
    else if (dato == 20) {
      style = "black";
    }
    else {
      style = "#ffffff"
    }
    return style;
  }

  fondo_estatus(dato) {
    var style = "";
    ////console.log(dato);
    if (dato == 25) {
      style = "red"
    }
    else if (dato == 20) {
      style = "cyan";
    }
    else {
      style = "#001975"
    }
    return style;
  }


  responsivos() {

    let x = (window.innerWidth / 20);
    var tamano_item = x;

    //////////////////////////////////////////////////////////////////////////////////
    let temp_tamano_lbl_titulo = ((tamano_item / 10) * 4);
    if (temp_tamano_lbl_titulo >= 25) {
      temp_tamano_lbl_titulo = 25;
    }

    else if (temp_tamano_lbl_titulo <= 17) {
      temp_tamano_lbl_titulo = 17;
    }
    this.tamano_lbl_titulo = temp_tamano_lbl_titulo + 'px';

    //////////////////////////////////////////////////////////////////////////////////
    let temp_tamano_lbl_locacion = ((tamano_item / 10) * 2);
    if (temp_tamano_lbl_locacion >= 20) {
      temp_tamano_lbl_locacion = 20;
    }

    else if (temp_tamano_lbl_locacion <= 12) {
      temp_tamano_lbl_locacion = 12;
    }

    this.tamano_lbl_locacion = temp_tamano_lbl_locacion + 'px';
    this.tamano_lbl_input = temp_tamano_lbl_locacion + 'px';

    //////////////////////////////////////////////////////////////////////////////////
    let temp_tamano_lbl_fecha = ((tamano_item / 10) * 2);
    if (temp_tamano_lbl_fecha >= 20) {
      temp_tamano_lbl_fecha = 20;
    }

    else if (temp_tamano_lbl_fecha <= 11) {
      temp_tamano_lbl_fecha = 11;
    }

    this.tamano_lbl_fecha = (temp_tamano_lbl_fecha + 2) + 'px';

    //////////////////////////////////////////////////////////////////////////////////
    let temp_tamano_lbl_titulo_tabla = ((tamano_item / 10) * 2.3);
    if (temp_tamano_lbl_titulo_tabla >= 16) {
      temp_tamano_lbl_titulo_tabla = 16;
    }

    else if (temp_tamano_lbl_titulo_tabla <= 7) {
      temp_tamano_lbl_titulo_tabla = 7;
    }


    this.tamano_lbl_titulo_tabla = temp_tamano_lbl_titulo_tabla + 'px';
    this.tamano_lbl_texto_tabla = temp_tamano_lbl_titulo_tabla + 'px';
    this.tamano_lbl_texto_tabla_moneda = (temp_tamano_lbl_titulo_tabla - 2) + 'px';


    ///////////////////////   Movil  vertical ///////////////////////////////////////


    //////////////////////////////////////////////////////////////////////////////////
    let temp_tamano_lbl_texto_tabla_vertical_moneda = ((window.innerWidth / 100) * 3.8);
    if (temp_tamano_lbl_texto_tabla_vertical_moneda >= 13) {
      temp_tamano_lbl_texto_tabla_vertical_moneda = 13;
    }

    else if (temp_tamano_lbl_texto_tabla_vertical_moneda <= 6) {
      temp_tamano_lbl_texto_tabla_vertical_moneda = 6;
    }

    this.tamano_lbl_texto_tabla_vertical = temp_tamano_lbl_texto_tabla_vertical_moneda + "px";
    this.tamano_lbl_texto_tabla_vertical_moneda = (temp_tamano_lbl_texto_tabla_vertical_moneda - 2) + "px";



  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.responsivos();
  }

}



// WEBPACK FOOTER //
// ./src/components/pedidos/pedidos.ts